import { SHORTCUT_SECTION_ID, ShortcutEntry, ShortcutSection } from "@/types";

export const GLOBAL_SHORTCUTS: ShortcutEntry[] = [
  { keys: "⌘K", description: "Open global search" },
  { keys: "Ctrl T", description: "Open task tracker" },
  { keys: "Ctrl N", description: "Toggle notifications panel" },
  { keys: "⇧?", description: "Show keyboard shortcuts" },
];

export const SHORTCUT_SECTIONS: ShortcutSection[] = [
  {
    id: SHORTCUT_SECTION_ID.CANDIDATE_SHEET,
    label: "Candidate Sheet",
    shortcuts: [
      { keys: "⌘⇧<", description: "Previous candidate" },
      { keys: "⌘⇧>", description: "Next candidate" },
      { keys: "R", description: "Open reject dialog" },
      { keys: "S", description: "Open score dialog" },
      {
        keys: "1–5",
        description:
          "Set star rating (when score or rejection dropdowns are open)",
      },
      {
        keys: "⌘↵",
        description: "Submit candidacy score, rejection, or internal comment",
      },
      { keys: "⇧↵", description: "Add Interview (if Interview tab selected)" },
    ],
  },
  {
    id: SHORTCUT_SECTION_ID.SEARCH_RESULT_SHEET,
    label: "Search Result Sheet",
    shortcuts: [
      { keys: "⌘⇧<", description: "Previous result" },
      { keys: "⌘⇧>", description: "Next result" },
      { keys: "⌘I", description: "Mark Not Interested" },
      { keys: "⌘J", description: "Source candidate" },
    ],
  },
  {
    id: SHORTCUT_SECTION_ID.JOB_UPDATE_MODAL,
    label: "Job Update Modal",
    shortcuts: [
      { keys: "⌘⇧<", description: "Previous job" },
      { keys: "⌘⇧>", description: "Next job" },
      { keys: "⌘↵", description: "Save & Next / Save & Close" },
    ],
  },
  {
    id: SHORTCUT_SECTION_ID.COMPANY_JOB_INTAKE,
    label: "Company / Job Intake",
    shortcuts: [
      { keys: "E", description: "Enter edit mode" },
      { keys: "Esc", description: "Exit edit mode" },
      { keys: "⌘⇧<", description: "Previous tab" },
      { keys: "⌘⇧>", description: "Next tab" },
    ],
  },
  {
    id: SHORTCUT_SECTION_ID.REQUISITIONS,
    label: "Requisitions",
    shortcuts: [{ keys: "⇧↵", description: "Add requisition row" }],
  },
  {
    id: SHORTCUT_SECTION_ID.JOB_PAGE,
    label: "Job Page",
    shortcuts: [
      { keys: "⇧Q", description: "Go to Pipeline tab" },
      { keys: "⇧W", description: "Go to Overview tab" },
      { keys: "⇧E", description: "Go to Edit Job tab" },
      { keys: "⇧S", description: "Go to Search tab" },
      { keys: "1", description: "Interest hovered search result" },
      { keys: "2", description: "Hide hovered search result" },
      { keys: "U", description: "Undo last 1 / 2 decision" },
    ],
  },
];
